import { render, staticRenderFns } from "./candidateList.vue?vue&type=template&id=a851abc4&scoped=true"
import script from "./candidateList.vue?vue&type=script&lang=js"
export * from "./candidateList.vue?vue&type=script&lang=js"
import style0 from "./candidateList.vue?vue&type=style&index=0&id=a851abc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851abc4",
  null
  
)

export default component.exports